import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/api/v1-jwt/config/api";
import { useAuth } from "@/providers/auth";

export const useCancelPayment = () => {
  const queryClient = useQueryClient();
  const { cognitoId, clientId, userRole } = useAuth();
  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useMutation({
    mutationFn: async (paymentId) =>
      await api.delete(`/platform/payments/${userId}/${paymentId}`),
    onSuccess: () => {
      queryClient.invalidateQueries(["invoices"]);
    },
  });
};
